export const messages = {
  buyTogether: {
    recap: {
      id: 'admin/promotions.form.review.alert.buy-together.recap',
    },
  },
  buyAndWin: {
    recap: {
      id: 'admin/promotions.form.review.alert.buy-and-win.recap',
    },
  },
  moreForLess: {
    recap: {
      id: 'admin/promotions.form.review.alert.more-for-less.recap',
    },
  },
  progressive: {
    recap: {
      id: 'admin/promotions.form.review.alert.progressive-discount.recap',
    },
  },
}
